import { render, staticRenderFns } from "./CheckNote.vue?vue&type=template&id=da52ec5a&"
import script from "./CheckNote.vue?vue&type=script&lang=ts&"
export * from "./CheckNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports